import React, { useContext } from 'react';
import { Button } from 'rsuite';
import PriceCell from '../Detail/PriceCell';
import { CartContext } from '../../Context/CartContext';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

function PriceView(props) {
  const colHeaderClass = "w-48 whitespace-no-wrap text-center p-1 bg-cruise_darkblue-10 ";
  const rowHeaderClass = "text-sm p-2 bg-gray-200 text-center border-solid border-t-0 border-gray-900 whitespace-no-wrap "
  const selectedDateClass = "font-normal text-white text-center p-2 bg-cruise_cyan border border-t-0 border-solid border-gray-900";
  const priceButtonClass = "text-cruise_darkblue text-center text-sm px-2 py-1 whitespace-no-wrap border-t-2 hover:bg-gray-200 ";
  const selectedPriceClass = priceButtonClass + " font-semibold ";
  const lowestPriceClass = "text-center bg-cruise_lightblue-secondary hover:bg-green-300 py-1 font-semibold border-gray-400 ";

  const [cart, setCart] = useContext(CartContext);

  function addDays(date, days) {
    var newDate = new Date(date);
    return newDate.setDate(newDate.getDate() + days);
  }
  function handleSelection(master, cp, cabinIndex, cabinttype, price) {
    let updatedCart = { ...cart };
    updatedCart.masterId = master.id;
    updatedCart.packageId = cp.id;
    updatedCart.departure = cp.departure;
    updatedCart.name = master.name;

    let grid = cp.priceGrids[cabinIndex];
    let cabin = {
      price: parseInt(price),
      cabintypeId: cabinttype.id,
      cabintypeName: cabinttype.name,
      adults: grid.adults,
      seniors: grid.seniors,
      children: grid.children,
      juniorChildren: grid.juniorChildren,
      infants: grid.infants,
    };
    if (updatedCart.cabins.length > cabinIndex)
      updatedCart.cabins[cabinIndex] = cabin;
    else
      updatedCart.cabins.push(cabin);

    setCart(updatedCart);
  }
  function isSelected(cp, primaryType, index) {
    if (cart.cabins[index]) {
      let selectedCabintype = cart.cabins[index].cabintypeId;
      if (cart.departure === cp.departure && selectedCabintype === primaryType.id) {
        return true;
      }
    }

    return false;
  }
  function getWrapperClass(cp, primaryType, index) {
    // if this is the price that is included in the shown price  => selectedPriceClass
    // pricegrid contains the cabintypeId of the used price.
    let wrapperClass = priceButtonClass;
    if (isSelected(cp, primaryType, index)) {
      wrapperClass = selectedPriceClass;
    }
    return wrapperClass;
  }
  function getPriceClass(cp, primaryType, index) {
    // if this is the price that is included in the shown price  => selectedPriceClass
    // pricegrid contains the cabintypeId of the used price.
    let wrapperClass = "text-cruise_darkblue";

    if (cart.departure === cp.departure) {
      wrapperClass += "";
    }

    wrapperClass += props.selectable ? " cursor-pointer" : " cursor-default";
    return wrapperClass;
  }
  function getPrice(pricegrid, primaryType) {
    if (pricegrid.priceGridRows) {
      var priceObj = pricegrid.priceGridRows.find(x => x.cabinCategoryPrimaryTypeId === primaryType.id);
      if (priceObj)
        return parseInt(priceObj.priceGridCell.lowestPrice / 100);
      return null;
    }
    return null;
  }
  function renderTD(cp, ptype, index) {
    return <PriceCell
      key={ptype.id + "_" + cp.id}
      selected={isSelected(cp, ptype, index)}
      selectable={props.selectable}
      handleSelection={(e) => handleSelection(props.selectedCruise, cp, index, ptype, getPrice(cp.priceGrids[index], ptype))}
      price={getPrice(cp.priceGrids[index], ptype)}
      cabintype={ptype.name}
    />
  }
  function renderTH() {
    if (props.horizontal) {
      return <React.Fragment>
        {props.cabinprimarytypes.map((ptype) =>
          <th key={'head-' + ptype.id} className={colHeaderClass}>
            {ptype.name}
          </th>
        )}
      </React.Fragment>
    }

    return <React.Fragment>
      <th className="absolute h-10 bg-white" style={{minWidth: 115 }}></th>
      <th></th>
      {props.selectedCruise.cruisePackages.map((cp) =>
        <th key={'head-' + cp.id}
          className={colHeaderClass} >
          <div className="">
            {
              new Intl.DateTimeFormat("en-GB", {
                day: "2-digit",
                month: "short"
              }).format(new Date(cp.departure))
            }
          </div>
        </th>
      )}
      <th className="w-4"></th>
    </React.Fragment>
  }
  function renderTBody(index) {
    if (props.horizontal) { // dates to the left
      return <React.Fragment>
        {props.selectedCruise.cruisePackages.map((cp) =>
          <tr key={cp.id}>
            <th className={props.selectedDate == new Date(cp.departure) ? selectedDateClass : rowHeaderClass}>
              {new Intl.DateTimeFormat("en-GB", {
                day: "2-digit",
                month: "long"
              }).format(new Date(cp.departure))}
            </th>
            {props.cabinprimarytypes.map((ptype) =>
              renderTD(cp, ptype, index)
            )}
          </tr>
        )}
      </React.Fragment>
    }

    return <React.Fragment>
      {
        props.cabinprimarytypes.map((ptype) =>
          <tr key={ptype.id} >
            <th style={{minWidth: 115 }}
              className="absolute text-cruise_darkblue font-semibold px-4 py-1 text-left bg-white" >
              {ptype.name}
            </th>
            <td style={{minWidth: 115 }}></td>
            {props.selectedCruise.cruisePackages.map((cp) =>
              renderTD(cp, ptype, index)
            )}
            <td></td>
          </tr>
        )
      }
    </React.Fragment>
  }
  function renderCabinInfo(persons, index) {
    let info = "";

    info = addInfo(persons.adults, "adult", info);
    info = addInfo(persons.seniors, "senior", info);
    info = addInfo(persons.children, "child", info);
    info = addInfo(persons.juniorChildren, "junior-child", info);
    info = addInfo(persons.infants, "infant", info);

    if (cart.cabins.length > index) {
      let cabintypeName = cart.cabins[index].cabintypeName;
      if (cabintypeName)
        info += ", " + cabintypeName;
    }

    return <React.Fragment>
      <th className="h-12"></th>
      <th colSpan={props.selectedCruise.cruisePackages.length + 2}
        className="absolute w-full flex items-center text-left bg-cruise_lightblue-secondary text-cruise_darkblue font-semibold h-12">
        <span className="px-4">Cabin {index + 1}</span><span className="px-8">{info}</span>
      </th>
    </React.Fragment>
  }
  function addInfo(numberOfPerson, nameOfPerson, currentInfo) {
    if (numberOfPerson > 0) {
      if (currentInfo.length > 0) currentInfo += ", ";
      currentInfo += numberOfPerson + " " + nameOfPerson;
      if (numberOfPerson > 1) {
        if (nameOfPerson.endsWith("hild")) currentInfo += "ren";
        else currentInfo += "s";
      }
    }

    return currentInfo;
  }
  
  return (
    <div className={props.wrapperClass}>
      <h5 className="font-semibold p-4 bg-cruise_darkblue text-white ">{props.selectedCruise.name}</h5>
      <table key={props.selectedCruise.id} className="w-full border table-fixed block overflow-x-auto overflow-y-hidden" >
        {props.selectedCruise.cruisePackages[0].priceGrids.map((grid, index) =>
          <React.Fragment key={"pricegroup_" + index}>
            <thead>
              <tr>
                {renderCabinInfo(grid, index)}
              </tr>
              <tr>
                <th colSpan={props.selectedCruise.cruisePackages.length + 3} className="h-3"></th>
              </tr>
            </thead>
            <tbody className="">
              <tr className="font-semibold ">
                {renderTH()}
              </tr>
              {renderTBody(index)}
            </tbody>
          </React.Fragment>
        )}
      </table>
      {props.showNavigation ?
        <div className="flex">
          <div className="p-4" >
            <Button
              onClick={props.handleDescriptionViewChange}
              color="orange" size="xs" appearance="subtle">
              <p className="underline">See description</p>
            </Button>
          </div>
          <div className="p-4" >
            <Button
              onClick={props.handleMapViewChange}
              color="orange" size="xs" appearance="subtle">
              <p className="underline">See map</p>
            </Button>
          </div>
        </div>
        : null}
    </div>
  );
}

PriceView.defaultProps = {
  showNavigation: true,
  horizontal: false,
  selectable: true,
};

export default PriceView;